import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type {
  GetIncotermsQuery,
  GetIncotermsQueryVariables,
  IncotermsDefinitionMap,
  IncotermsListFailure,
} from "@/graphql/codegen/graphql"
import { GetIncotermsDocument } from "@/graphql/codegen/graphql"

interface UseGetIncotermsQueryResult {
  data: IncotermsDefinitionMap[]
  fetching: boolean
}

export const useGetIncotermsQuery = (): UseGetIncotermsQueryResult => {
  const [{ data, fetching, error }] = useQuery<GetIncotermsQuery, GetIncotermsQueryVariables>({
    query: GetIncotermsDocument,
  })

  const [incoterms, setIncoterms] = useState<IncotermsDefinitionMap[]>([])

  useEffect(() => {
    if (error || data?.incoterms?.listIncoterms?.__typename === "IncotermsListFailure") {
      console.error(error || (data?.incoterms?.listIncoterms as IncotermsListFailure)?.error)
      return
    }
    if (data?.incoterms?.listIncoterms?.__typename === "IncotermsListSuccess") {
      const list = data?.incoterms?.listIncoterms?.incoterms || []
      setIncoterms(list)
    }
  }, [data, error])

  return {
    data: incoterms,
    fetching,
  }
}
